import Vue from "vue";
import VueRouter from "vue-router";
import { getToken } from "@/utils/auth";
Vue.use(VueRouter);

const routes = [
    // {
    //     path: "/",
    //     name: "login",
    //     component: () => import("../views/login/login.vue"),
    //     meta: {
    //         title: "登录"
    //     }
    // },
    {
        path: "/stop",
        name: "stop",
        component: () => import("../views/stop.vue"),
        meta: {
            title: "申报截止"
        }
    },
    {
        path: "/",
        redirect: "/index"
    },
    {
        path: "/login-register",
        name: "login-register",
        component: () => import("../views/login/login-register.vue"),
        meta: {
            title: "忘记密码"
        }
    },
    {
        path: "/auth-login",
        name: "auth-login",
        component: () => import("../views/login/auth-login.vue"),
        meta: {
            title: "统一身份认证登录"
        }
    },
    {
        path: "/declare",
        name: "declare",
        meta: {
            title: "特色产业园申报"
        },
        component: () => import("../views/declare/index.vue"),
        children: [
            // {
            //     path: "list", //特色产业园申报
            //     component: () => import("../views/declare/list.vue"),
            //     meta: {
            //         title: "特色产业园申报"
            //     }
            // },
            {
                path: "add", //特色产业园申报
                component: () => import("../views/declare/add.vue"),
                meta: {
                    title: "特色产业园申报"
                }
            },
            {
                path: "submit",
                component: () => import("../views/declare/submit.vue"),
                meta: {
                    title: "申报书"
                }
            }
        ]
    },
    {
        path: "/park-declare",
        name: "park-declare",
        meta: {
            title: "特色产业园申报"
        },
        component: () => import("../views/park-declare/index.vue"),
        children: [
            {
                path: "add",
                component: () => import("../views/park-declare/add.vue"),
                meta: {
                    title: "特色产业园申报"
                }
            }
        ]
    },
    {
        path: "/park-evaluate-declare",
        name: "park-evaluate-declare",
        meta: {
            title: "园区评价填报"
        },
        component: () => import("../views/park-declare/index.vue"),
        children: [
            {
                path: "add",
                component: () => import("../views/park-evaluate-declare/add.vue"),
                meta: {
                    title: "园区评价填报"
                }
            }
        ]
    },
    {
        path: "/", //根路径
        name: "home",
        meta: {
            title: "中关村高新技术企业bei认定管理"
        },
        component: () => import("../views/index.vue"), //主布局组件
        children: [
            {
                path: "index", //首页
                name: "index",
                component: () => import("../views/index/index.vue"),
                meta: {
                    title: "首页"
                }
            },
            {
                path: "declare/list", //特色产业园申报
                component: () => import("../views/declare/list.vue"),
                meta: {
                    title: "特色产业园申报"
                }
            },
            // {
            //   path: "declare/add", //特色产业园申报
            //   component: () => import("../views/declare/add.vue"),
            //   meta: {
            //     title: "特色产业园申报"
            //   }
            // },
            {
                path: "user-info", //用户信息
                name: "user-info",
                component: () => import("../views/user-info/index.vue"),
                meta: {
                    title: "用户信息"
                }
            },
            {
                path: "user-edit", //用户信息
                name: "user-edit",
                component: () => import("../views/user-info/user-edit.vue"),
                meta: {
                    title: "编辑用户信息"
                }
            },
            {
                path: "user-look", //用户信息
                name: "user-look",
                component: () => import("../views/user-info/user-look.vue"),
                meta: {
                    title: "查看用户信息"
                }
            },
            {
                //notice
                path: "notice", //通知通告
                name: "notice",
                component: () => import("../views/notice/index.vue"),
                meta: {
                    title: "通知通告"
                },
                children: [
                    {
                        path: "info", //通知通告
                        name: "info",
                        component: () => import("../views/notice/info.vue"),
                        meta: {
                            title: "通知通告"
                        }
                    },
                    {
                        path: "info-index", //通知通告
                        name: "info-index",
                        component: () => import("../views/notice/info-index.vue"),
                        meta: {
                            title: "通知通告"
                        }
                    },
                    {
                        path: "download", //文件下载
                        name: "download",
                        component: () => import("../views/notice/download.vue"),
                        meta: {
                            title: "文件下载"
                        }
                    },
                    {
                        path: "download-index", //文件下载
                        name: "download-index",
                        component: () => import("../views/notice/download-index.vue"),
                        meta: {
                            title: "文件下载"
                        }
                    }
                ]
            },
            {
                path: "park-evaluate",
                name: "park-evaluate",
                component: () => import("../views/park-evaluate/index.vue"),
                meta: {
                    title: "园区评价"
                }
            }
        ]
    }
];

const router = new VueRouter({
    mode: "history",
    base: "/tscyyClient",
    routes
});

router.beforeEach(async (to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    if (!getToken() && to.name !== "login" && to.name !== "login-register" && to.name !== "auth-login" && to.name !== "stop") {
        next({ name: "auth-login" });
    } else {
        next();
    }
});

export default router;
